export default "__VITE_ASSET__Co_FgmjB__"